import { render, staticRenderFns } from "./transactionStatusPanel.vue?vue&type=template&id=2b8826b0&scoped=true&"
import script from "./transactionStatusPanel.vue?vue&type=script&lang=js&"
export * from "./transactionStatusPanel.vue?vue&type=script&lang=js&"
import style0 from "./transactionStatusPanel.vue?vue&type=style&index=0&id=2b8826b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8826b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8826b0')) {
      api.createRecord('2b8826b0', component.options)
    } else {
      api.reload('2b8826b0', component.options)
    }
    module.hot.accept("./transactionStatusPanel.vue?vue&type=template&id=2b8826b0&scoped=true&", function () {
      api.rerender('2b8826b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/transactionStatusPanel.vue"
export default component.exports